// extracted by mini-css-extract-plugin
export var banner = "_1u-0";
export var icon = "_1u-1";
export var message = "_1u-2";